import { render, staticRenderFns } from "./shipin.vue?vue&type=template&id=5d40b71e&scoped=true"
import script from "./shipin.vue?vue&type=script&lang=js"
export * from "./shipin.vue?vue&type=script&lang=js"
import style0 from "./shipin.vue?vue&type=style&index=0&id=5d40b71e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d40b71e",
  null
  
)

export default component.exports